"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_COLOR = exports.MessageBannerTypeIcons = exports.MessageBannerTypeColors = exports.MessageBannerIconColors = exports.MessageBannerDefaultProps = exports.MessageBannerDefaultAltTexts = exports.FONT_SIZE = exports.BANNER_PADDING = exports.BANNER_MIN_HEIGHT = exports.BANNER_BORDER_WIDTH = exports.BANNER_BAR_WIDTH = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _icons = require("../icons");

var _interfaces = require("./interfaces");

var _MessageBannerTypeCol, _MessageBannerTypeIco, _MessageBannerDefault;

var TEXT_COLOR = 'neutral90';
exports.TEXT_COLOR = TEXT_COLOR;
var FONT_SIZE = 'T200';
exports.FONT_SIZE = FONT_SIZE;
var BANNER_PADDING = 16;
exports.BANNER_PADDING = BANNER_PADDING;
var BANNER_BAR_WIDTH = 8;
exports.BANNER_BAR_WIDTH = BANNER_BAR_WIDTH;
var BANNER_BORDER_WIDTH = 2;
exports.BANNER_BORDER_WIDTH = BANNER_BORDER_WIDTH;
var BANNER_MIN_HEIGHT = 48;
exports.BANNER_MIN_HEIGHT = BANNER_MIN_HEIGHT;
var MessageBannerTypeColors = (_MessageBannerTypeCol = {}, (0, _defineProperty2.default)(_MessageBannerTypeCol, _interfaces.MessageBannerType.Informational, 'primary'), (0, _defineProperty2.default)(_MessageBannerTypeCol, _interfaces.MessageBannerType.Warning, 'yellow'), (0, _defineProperty2.default)(_MessageBannerTypeCol, _interfaces.MessageBannerType.Error, 'red'), (0, _defineProperty2.default)(_MessageBannerTypeCol, _interfaces.MessageBannerType.Success, 'green'), (0, _defineProperty2.default)(_MessageBannerTypeCol, _interfaces.MessageBannerType.Bias, 'pink'), _MessageBannerTypeCol);
exports.MessageBannerTypeColors = MessageBannerTypeColors;
var MessageBannerIconColors = {
  primary: 'primary70',
  green: 'green70',
  yellow: 'yellow70',
  red: 'red70',
  pink: 'pink70'
};
exports.MessageBannerIconColors = MessageBannerIconColors;
var MessageBannerTypeIcons = (_MessageBannerTypeIco = {}, (0, _defineProperty2.default)(_MessageBannerTypeIco, _interfaces.MessageBannerType.Informational, _icons.IconInformationFill), (0, _defineProperty2.default)(_MessageBannerTypeIco, _interfaces.MessageBannerType.Warning, _icons.IconAlertTriangleFill), (0, _defineProperty2.default)(_MessageBannerTypeIco, _interfaces.MessageBannerType.Error, _icons.IconAlertCircleFill), (0, _defineProperty2.default)(_MessageBannerTypeIco, _interfaces.MessageBannerType.Success, _icons.IconCheckCircleFill), (0, _defineProperty2.default)(_MessageBannerTypeIco, _interfaces.MessageBannerType.Bias, _icons.IconQuestionCircleFill), _MessageBannerTypeIco);
exports.MessageBannerTypeIcons = MessageBannerTypeIcons;
var MessageBannerDefaultAltTexts = (_MessageBannerDefault = {}, (0, _defineProperty2.default)(_MessageBannerDefault, _interfaces.MessageBannerType.Informational, 'Information'), (0, _defineProperty2.default)(_MessageBannerDefault, _interfaces.MessageBannerType.Warning, 'Warning'), (0, _defineProperty2.default)(_MessageBannerDefault, _interfaces.MessageBannerType.Error, 'Error'), (0, _defineProperty2.default)(_MessageBannerDefault, _interfaces.MessageBannerType.Success, 'Success!'), (0, _defineProperty2.default)(_MessageBannerDefault, _interfaces.MessageBannerType.Bias, 'Attention'), _MessageBannerDefault);
exports.MessageBannerDefaultAltTexts = MessageBannerDefaultAltTexts;
var MessageBannerDefaultProps = {
  dismissButtonAltText: 'Dismiss',
  type: _interfaces.MessageBannerType.Informational
};
exports.MessageBannerDefaultProps = MessageBannerDefaultProps;